export default __webpack_public_path__ + "static/media/photo--sm--83.bf025f83.jpg";